export const PickerTypeCode = {
  ALL: 0,
  SELF: 1,
  COMPANY: 2,
  SELLER: 3
}

export const PickerStatusStr = {
  0: '',
  1: '待发货',
  2: '待收货',
  3: '已收货',
  4: '已取消',
  5: '待出库'
}
